import { IconButton, makeStyles, Typography } from '@material-ui/core';
import { groupRelatedObjectives } from '../../../utils/objectives';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { OpenInNew } from '@material-ui/icons';
import { formatDate } from '../../../utils/dates';
import clsx from 'clsx';

const useStyles = makeStyles({
  group: {
    marginTop: 8,
    borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
    borderRight: '1px solid rgba(0, 0, 0, 0.12)'
  },
  groupTitle: {
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    background: '#F4F4F4',
    padding: 16
  },
  listRow: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 48px',
    gridGap: 8,
    alignItems: 'center',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    padding: '8px 16px'
  },
  listHeader: {
    '& p': {
      color: '#999999',
      fontSize: 11,
      textTransform: 'uppercase'
    }
  },
  listItem: {
    '& p': {
      fontSize: 13
    }
  },
  noRelated: {
    marginTop: '30px'
  }
}, { name: 'RelatedObjectives' });

const RelatedObjectives = ({ objective, objectiveRelations }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const groupedRelatedObjectives = groupRelatedObjectives({
    objective,
    objectiveRelations
  });

  return (
    <>
      <Typography>{t('objective.relation.title')}</Typography>
      { groupedRelatedObjectives.length > 0 ?
        groupedRelatedObjectives.map(group => (
          <div
            key={ group.title }
            className={ classes.group }
          >
            <Typography className={ classes.groupTitle }>
              {t(`objective.relation.types.${group.title}`)}
            </Typography>
            <div
              className={ clsx(classes.listRow, classes.listHeader) }
            >
              <Typography>
                {t('objective.listHeader.name')}
              </Typography>
              <Typography>
                {t('objective.listHeader.deadline')}
              </Typography>
              <Typography>
                {t('objective.listHeader.category')}
              </Typography>
            </div>
            {
              group.objectiveRelations.map(objectiveRelation => (
                <div
                  key={ objectiveRelation.objective_relations_id }
                  className={ clsx(classes.listRow, classes.listItem) }
                >
                  <Typography>
                    {objectiveRelation.objective.owner[0].name} - {objectiveRelation.objective.name}
                  </Typography>

                  <Typography>
                    {formatDate(new Date(objectiveRelation.objective.deadline))}
                  </Typography>

                  <Typography>
                    {objectiveRelation.objective.category}
                  </Typography>
                  <div>
                    <IconButton
                      component={ Link }
                      target='_blank'
                      to={ `/objective/${objectiveRelation.objective.objective_id}` }
                    >
                      <OpenInNew />
                    </IconButton>
                  </div>
                </div>
              ))
            }
          </div>
        )) :
        <Typography
          variant="body2"
          className={ classes.group }
        >
          {t('objective.relation.noRelated')}
        </Typography>
      }
    </>
  );
};

export default RelatedObjectives;